import { generatePath } from 'react-router';
// Wrapper over the `generatePath` function from react-router, which generates
// a route that has been cast as a `RouteString`. This is needed because our
// routes are typed as static strings, which would otherwise cause a TS error
// whenever a path parameter route is used (e.g. "document-uploads/delete/123").
export var generateLinkPath = function (route, routeParams) {
    return generatePath(route, routeParams);
};
